import { render } from "./IllustrationsUploader.vue?vue&type=template&id=c18f59d8"
import script from "./IllustrationsUploader.vue?vue&type=script&lang=js"
export * from "./IllustrationsUploader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__